import { computed, type Ref, ref } from 'vue'

export const useStopwatch = (): {
  start: () => void
  stop: () => number
  reading: Readonly<Ref<number>>
} => {
  const startTime = ref(0)
  const endTime = ref(0)
  const reading = computed(() => endTime.value - startTime.value)

  return {
    start: () => {
      startTime.value = Date.now()
    },
    stop: (): number => {
      endTime.value = Date.now()
      return reading.value
    },
    reading,
  }
}
